import Axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./movie.scss";
import { message } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";

const Movie = () => {
  let { id } = useParams();
  const [movie, setMovie] = useState(null);

  useEffect(() => {
    if (!movie) {
      Axios.get(`https://backendexample.sanbersy.com/api/data-movie/${id}`)
        .then((response) => {
          setMovie(response.data);
        })
    }
  });
  return movie ? (
    <div className="content">
      <div className="content__background">
        <div className="content__background__shadow" />
        <div
          className="content__background__image"
          style={{ backgroundImage: `url(${movie.image_url})` }}
        />
      </div>
      <div className="content__area">
        <div className="content__area__container">
          <div className="content__title">{movie.title}</div>
          <div className="content__description">{movie.description}</div>
          <div className="content__year">Release : {movie.year}</div>
          <div className="content__duration">
            Duration : {movie.duration} Minutes
          </div>
          <div className="content__genre">Genre : {movie.genre}</div>
          <div className="content__rating">Rating : {movie.rating}/10</div>
          <div className="content__rating">{movie.review ? "Review : " + movie.review : ""}</div>
          <div style={{ marginTop: "12vh", display: "flex", "justifyContent": "space-between", width: "100%" }}>
            <div
              style={{
                color: "white",
                fontSize: "1.4rem",
                cursor: "pointer",
              }}
            >
              <Link to="/" style={{ color: "#fff" }}>
                <ArrowLeftOutlined /> Back To Home{" "}
              </Link>
            </div>
            <div
              style={{
                color: "white",
                fontSize: "1.4rem",
                cursor: "pointer",
              }}
            >
              <Link to="/movie_list" style={{ color: "#fff" }}>
                See All Movies <ArrowRightOutlined />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
      ""
    );
};

export default Movie;
